import { Button, Modal } from "react-bootstrap";
import { useEffect, useMemo } from "react";

import { GET_FULL_LINES_WORKER_INFO } from "../../graphql/checkin.graphql";
import S3ImageNew from "../S3ImageNew";
import Table from "../../components/Table/Table";
import clsx from "clsx";
import { getHourAndMinute } from "../../utils/date-utils";
import { useLazyQuery } from "@apollo/client";
import { useTranslation } from "next-i18next";

const WorkerInfoModal = ({ open, toggleModal, worker, job }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const onCancel = () => {
    toggleModal();
  };

  const [loadDetailTimelogs, loadDetailTimelogsQuery] = useLazyQuery(
    GET_FULL_LINES_WORKER_INFO,
    { fetchPolicy: "network-only" }
  );

  useEffect(() => {
    if (worker.id && open) {
      loadDetailTimelogs({
        variables: {
          worker_id: worker.id,
          date: job?.date,
        },
      });
    }
  }, [loadDetailTimelogs, worker.id, open, job?.date]);

  const onResult = (rawTimelogs = []) => {
    const timelogs = rawTimelogs.map((timelog, index) => {
      const next = rawTimelogs[index + 1];
      const to = next
        ? next?.line?.number || t("views.dashboard.leader.miscLine")
        : "";

      const previous = rawTimelogs[index - 1];
      const from = previous
        ? previous?.line?.number || t("views.dashboard.leader.miscLine")
        : "";
      return {
        ...timelog,
        to,
        from,
      };
    });

    return timelogs || [];
  };

  const response =
    loadDetailTimelogsQuery.loading || loadDetailTimelogsQuery.error
      ? []
      : onResult(loadDetailTimelogsQuery?.data?.timelog);

  const columns = useMemo(
    () => [
      {
        id: "line_number",
        Header: t("views.checkin.info.line"),
        accessor: "line.number",
        Cell: (props) =>
          props.row?.values["line_number"]
            ? `${t("views.checkin.info.line")} ${
                props.row?.values?.line_number
              } `
            : t("views.dashboard.leader.miscLine"),
      },
      {
        Header: t("views.checkin.info.startTime"),
        accessor: "start_time",
        Cell: (props) =>
          getHourAndMinute(props.row?.values?.start_time, language),
        transformData: (start_time) => getHourAndMinute(start_time, language),
      },
      {
        Header: t("views.checkin.info.stopTime"),
        accessor: "stop_time",
        Cell: (props) =>
          getHourAndMinute(props.row?.values?.stop_time, language) || (
            <p className="mb-0" style={{ color: "#9ba9b5" }}>
              {t("views.lines.timelog.working")}
            </p>
          ),

        transformData: (stop_time) =>
          getHourAndMinute(stop_time, language) ||
          t("views.lines.timelog.working"),
      },
      {
        id: "from",
        Header: t("views.lines.timelog.from"),
        accessor: "line.number",
      },
      {
        Header: t("views.lines.timelog.to"),
        accessor: "to",
      },
    ],
    [t, language]
  );
  return (
    <Modal show={open} onHide={onCancel} centered>
      <Modal.Header
        closeButton
        closeVariant="white"
        className="bg-dark"
        style={{
          borderColor: "#2253d4",
        }}
      >
        <h2 className="fw-bold text-light mb-0">
          {t("views.checkin.info.title")}
        </h2>
      </Modal.Header>
      <Modal.Body className="position-relative p-0">
        <div
          className="p-0 d-flex flex-column align-items-center"
          style={{ minHeight: 500 }}
        >
          <div className="w-100 bg-dark px-4" style={{ height: 97 }}></div>
          <div
            className="position-absolute w-100 d-flex justify-content-center"
            style={{ left: 0, top: 18 }}
          >
            <S3ImageNew
              imageKey={worker.picture}
              alt="mdo"
              width="128px"
              height="128px"
              className="rounded-circle position-absolute border border-4 border-primary bg-white"
            />
          </div>
          <h1 className="fw-bold" style={{ marginTop: 68, fontSize: 32 }}>
            {worker.first_name + " " + worker.last_name}
          </h1>
          <div className="d-flex flex-row w-100">
            <div className="w-50 border py-3  d-flex justify-content-center align-items-center ">
              <i className={clsx("icon-clor", "bi bi-briefcase-fill")} />
              <p className="fw-bold ms-2 m-0">{worker?.agency?.name}</p>
            </div>
            <div className="w-50 border py-3 d-flex justify-content-center align-items-center">
              <p className="fw-bold ms-2 m-0">
                {language === "es"
                  ? worker?.position?.comment_es
                  : worker?.position?.comment}
              </p>
            </div>
          </div>
          <Table
            data={response}
            embedded
            columns={columns}
            className="m-0 w-100"
            pageSize={10}
            loading={false}
            exportData={false}
            noActions={true}
            noHeader={true}
          />
        </div>
        <Modal.Footer className="w-100 d-flex justify-content-center">
          <Button variant="primary" onClick={onCancel} className="me-3">
            {t("general.close").toUpperCase()}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default WorkerInfoModal;
